import { render, staticRenderFns } from "./invoiceRedDialog.vue?vue&type=template&id=4b0b21e2"
import script from "./invoiceRedDialog.vue?vue&type=script&lang=js"
export * from "./invoiceRedDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports